import { Injectable } from '@angular/core';
import { Observable, defer, of, EMPTY } from 'rxjs';
import { mergeMap, map, withLatestFrom, filter } from 'rxjs/operators';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store, select, Action } from '@ngrx/store';
import { AppState } from '../../../core/reducers';
import { allRolesLoaded } from '../_selectors/role.selectors';
import {
    AllRolesLoaded,
    AllRolesRequested,
    RoleActionTypes,
    RolesPageToggleLoading,
    RolesActionToggleLoading
} from '../_actions/role.actions';

@Injectable()
export class RoleEffects {
    showPageLoadingDistpatcher = new RolesPageToggleLoading({ isLoading: true });
    hidePageLoadingDistpatcher = new RolesPageToggleLoading({ isLoading: false });
    showActionLoadingDistpatcher = new RolesActionToggleLoading({ isLoading: true });
    hideActionLoadingDistpatcher = new RolesActionToggleLoading({ isLoading: false });

    @Effect()
    loadAllRoles$ = this.actions$.pipe(
        ofType<AllRolesRequested>(RoleActionTypes.AllRolesRequested),
        withLatestFrom(this.store.pipe(select(allRolesLoaded))),
        filter(([action, isAllRolesLoaded]) => !isAllRolesLoaded),
        map(() => new AllRolesLoaded({ roles: [] }))
    );

    @Effect({ dispatch: false })
    loadRolesPage$ = this.actions$.pipe(
        ofType(RoleActionTypes.RolesPageRequested),
        mergeMap(() => EMPTY)
    );

    @Effect({ dispatch: false })
    deleteRole$ = this.actions$.pipe(
        ofType(RoleActionTypes.RoleDeleted),
        mergeMap(() => EMPTY)
    );

    @Effect({ dispatch: false })
    updateRole$ = this.actions$.pipe(
        ofType(RoleActionTypes.RoleUpdated),
        mergeMap(() => EMPTY)
    );

    @Effect({ dispatch: false })
    createRole$ = this.actions$.pipe(
        ofType(RoleActionTypes.RoleOnServerCreated),
        mergeMap(() => EMPTY)
    );

    @Effect()
    init$: Observable<Action> = defer(() => of(new AllRolesRequested()));

    constructor(private actions$: Actions, private store: Store<AppState>) {}
}